import { render, staticRenderFns } from "./Newpage.vue?vue&type=template&id=a56c3766&scoped=true&"
import script from "./Newpage.vue?vue&type=script&lang=js&"
export * from "./Newpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c3766",
  null
  
)

export default component.exports